import(/* webpackMode: "eager" */ "/codebuild/output/src2380773144/src/src/app/global-error.tsx");
